/**
 * Created by Angelika on 05.10.2017.
 */
import * as actionTypes from '../constants/actionTypes';
import StalkerApiManager from '../api/StalkerApiLoaderManager';
import {markAsFavorite} from './channels';

let api = StalkerApiManager.getInstance();
let loader = api.getLoader();

export function addFavorite(channel) {
    return dispatch => {
        dispatch({type: actionTypes.ADD_FAVORITE_REQUEST});
        return loader.addFavorite(channel).then(
            result => {
                dispatch({type: actionTypes.ADD_FAVORITE_SUCCESS});
                dispatch(markAsFavorite(channel, 1));
            },
            error => dispatch({type: actionTypes.ADD_FAVORITE_FAILED})
        )
    }
}

export function deleteFavorite(channel) {
    return dispatch => {
        dispatch({type: actionTypes.DELETE_FAVORITE_REQUST});
        return loader.deleteFavorite(channel).then(
            result => {
                dispatch({type: actionTypes.DELETE_FAVORITE_SUCCESS});
                dispatch(markAsFavorite(channel, 0));
            },
            error => dispatch({type: actionTypes.DELETE_FAVORITE_FAILED})
        )
    }
}


// WEBPACK FOOTER //
// ./src/actions/favorites.js